import UserSelectProvider from 'components/CIMSSelect/common/UserSelect/UserSelectContext'
import { RoutingGroupsTable } from './components/RoutingGroupsTable'
import { RoutingGroupsTableProvider } from './RoutingGroupsTableContext'

const RoutingGroups: React.FC = () => (
  <RoutingGroupsTableProvider>
    <UserSelectProvider>
      <RoutingGroupsTable />
    </UserSelectProvider>
  </RoutingGroupsTableProvider>
)

export default RoutingGroups
